import { TelegramCategoryTreeResponseDto } from '@/generated';

export const inefectiveFindElem = <
  T extends Pick<TelegramCategoryTreeResponseDto, 'id'> & { children: Pick<TelegramCategoryTreeResponseDto, 'id'>[] },
>(
  tree: T[],
  elemId: string,
  idKey = 'id',
  childrenKey = 'children',
) => {
  // Normalize to array of roots
  const rootArray = Array.isArray(tree) ? tree : [tree];

  // Stack for DFS: each item keeps a node and its parent reference
  const stack: any[] = [];
  // Map to reconstruct path: node -> parentNode (null for roots)
  const parentMap = new Map();

  for (const r of rootArray) {
    if (r && typeof r === 'object') {
      stack.push(r);
      parentMap.set(r, null);
    }
  }

  let found: T | null = null;

  while (stack.length) {
    const node = stack.pop();

    if (node?.[idKey] === elemId) {
      found = node;
      break;
    }

    const children = node?.[childrenKey];
    if (Array.isArray(children) && children?.length) {
      // Push children and record their parent
      for (let i = children.length - 1; i >= 0; i--) {
        const child = children[i];
        if (child && typeof child === 'object') {
          stack.push(child);
          parentMap.set(child, node);
        }
      }
    }
  }

  if (!found) {
    return { node: null, path: [], isElemNotFinal: false };
  }

  // Rebuild path of parents from found node back to root
  const path: T[] = [];
  let cur = parentMap.get(found);
  while (cur) {
    path.unshift(cur);
    cur = parentMap.get(cur);
  }

  const isElemNotFinal = (found.children && found.children.length > 0) || path.length === 0;

  return { node: found, path, isElemNotFinal };
};
